/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frontrow_BodyInputs */

const en_frontrow_body = /** @type {(inputs: Frontrow_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The buyer opens the invitation, books a visit to the showroom, then follows every order: confirmations to accept, documents, shipments and claims, from a phone first.`)
};

/**
* | output |
* | --- |
* | "The buyer opens the invitation, books a visit to the showroom, then follows every order: confirmations to accept, documents, shipments and claims, from a pho..." |
*
* @param {Frontrow_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const frontrow_body = /** @type {((inputs?: Frontrow_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frontrow_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_frontrow_body(inputs)
});